var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.158 8.79549C12.388 8.80849 11.651 8.21249 11.658 7.40149C11.652 6.59549 12.38 5.98749 13.158 6.00049C13.936 5.98649 14.657 6.59649 14.651 7.40149C14.658 8.21349 13.926 8.80949 13.158 8.79549ZM14.325 17.3875C13.178 17.8405 12.766 18.0085 12.077 17.9965C11.377 18.0395 10.124 17.6385 10.15 16.4205C10.152 15.0485 11.119 13.0275 11.133 11.8965C11.203 11.2275 10.647 10.8725 9.349 11.3565L9.515 10.6705C10.842 10.1355 11.284 10.0675 11.762 10.0625C12.789 9.99449 13.684 10.6565 13.653 11.6375C13.653 13.0185 12.718 14.9225 12.672 16.1605C12.565 17.0315 13.603 17.0785 14.491 16.7025L14.325 17.3875ZM19 3.00049H5C3.897 3.00049 3 3.89749 3 5.00049V19.0005C3 20.1025 3.897 21.0005 5 21.0005H19C20.102 21.0005 21 20.1025 21 19.0005V5.00049C21 3.89749 20.102 3.00049 19 3.00049Z",
    fill: "#185A7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.bf9993f82762a27382c6093316ee74a2.svg";
export { ForwardRef as ReactComponent };